module.exports = __webpack_public_path__ + "img/person-plus-fill.cedb206d.svg";